module.exports = __webpack_public_path__ + "static/media/dash-pending-icon.53b22d39.svg";